import { fetchBasicJsonPost, fetchBasicJsonPostJson, fetchBasicUrlGetJson, fetchBasicUrlPost, fetchBasicUrlPostJson, handleCommonResponse } from '@/script/common';

export default {
    listPrescription: data =>
        fetchBasicUrlGetJson('/DrugPrescription/List', { data }),
    createPrescription: (data) =>
        fetchBasicJsonPost('/DrugPrescription/Create', { data }),
    validateMaxQuantityPrescription: data =>
        handleCommonResponse(fetchBasicJsonPostJson('/DrugPrescription/ValidateMaxQuantity', { data })),
    createRangePrescription: (data) =>
        fetchBasicJsonPost('/DrugPrescription/CreateRange', { data }),
    updateAllAfterPrescription: (data) =>
        fetchBasicJsonPost('/DrugPrescription/UpdateAllAfter', { data }),
    updatePrescription: (data) =>
        fetchBasicJsonPost('/DrugPrescription/Update', { data }),
    updatePrescriptionTime: (data) =>
        fetchBasicJsonPost('/DrugPrescription/UpdateTime', { data }),
    deletePrescription: id =>
        fetchBasicJsonPost('/DrugPrescription/Delete', { data: id }),
    deletePrescriptionFrom: data =>
        fetchBasicJsonPost('/DrugPrescription/DeleteFrom', { data }),
    clearPrescriptionStopAt: data =>
        fetchBasicJsonPost('/DrugPrescription/ClearStopAt', { data }),
    copyPrescription: (id, datetime) =>
        fetchBasicJsonPost('/DrugPrescription/Copy', { data: { id, datetime } }),
    copy24HoursPrescription: (id, datetime) =>
        fetchBasicJsonPost('/DrugPrescription/Copy24Hours', { data: { id, datetime } }),
    copyAll24HoursPrescription: (id, datetime) =>
        fetchBasicJsonPost('/DrugPrescription/CopyAll24Hours', { data: { id, datetime } }),
    updatePrescriptionStatus: (id, status, dischargeInCaseOfFraction) =>
        fetchBasicUrlPost('/DrugPrescription/UpdateStatus', { data: { id, status, dischargeInCaseOfFraction } }),
    UsePrescription: (id, dischargeInCaseOfFraction) =>
        fetchBasicUrlPost('/DrugPrescription/Use', { data: { id, dischargeInCaseOfFraction } }),
    DeleteUsePrescription: id =>
        fetchBasicUrlPost('/DrugPrescription/DeleteUse', { data: { id } }),
    SetPrescriptionAsMyPrescription: id =>
        fetchBasicJsonPost('/DrugPrescription/SetAsMyPrescription', { data: id }),
    PrescriptionUsedByMe: id =>
        fetchBasicJsonPost('/DrugPrescription/UsedByMe', { data: id }),

    cocktailList: data =>
        fetchBasicUrlGetJson('/DrugCocktail/List', { data: data }),
    createCocktail: data =>
        fetchBasicJsonPost('/DrugCocktail/Create', { data: data }),
    validateMaxQuantityCocktail: data =>
        handleCommonResponse(fetchBasicJsonPostJson('/DrugCocktail/ValidateMaxQuantity', { data: data })),
    updateCocktail: data =>
        fetchBasicJsonPost('/DrugCocktail/Update', { data: data }),
    copyCocktail: (id, startAt) =>
        fetchBasicJsonPost('/DrugCocktail/Copy', { data: { id, startAt } }),
    splitCocktail: data =>
        fetchBasicJsonPost('/DrugCocktail/Split', { data: data }),
    stopCocktailAt: (id, stopAt) =>
        fetchBasicUrlPost('/DrugCocktail/StopAt', { data: { id, stopAt } }),
    deleteCocktail: id =>
        fetchBasicJsonPost('/DrugCocktail/Delete', { data: id }),
    updateCocktailStatus: (id, status) =>
        fetchBasicUrlPost('/DrugCocktail/UpdateStatus', { data: { id, status } }),
    useCocktail: id =>
        fetchBasicUrlPostJson('/DrugCocktail/Use', { data: { id } }),
    deleteUseCocktail: id =>
        fetchBasicUrlPost('/DrugCocktail/DeleteUse', { data: { id } }),
    cocktailQuantityToUse: id =>
        fetchBasicUrlGetJson('/DrugCocktail/QuantityToUse', { data: { id } }),
    SetCocktailAsMyPrescription: id =>
        fetchBasicJsonPost('/DrugCocktail/SetAsMyPrescription', { data: id }),
    CocktailUsedByMe: id =>
        fetchBasicJsonPost('/DrugCocktail/UsedByMe', { data: id }),

    createInvoice: data =>
        fetchBasicJsonPost('/Prescription/RequestMedicament', { data: data }),
}